import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { FlattenedEncrypt } from '../flattened/encrypt.js';
export var CompactEncrypt = /*#__PURE__*/function () {
  function CompactEncrypt(plaintext) {
    _classCallCheck(this, CompactEncrypt);

    this._flattened = new FlattenedEncrypt(plaintext);
  }

  _createClass(CompactEncrypt, [{
    key: "setContentEncryptionKey",
    value: function setContentEncryptionKey(cek) {
      this._flattened.setContentEncryptionKey(cek);

      return this;
    }
  }, {
    key: "setInitializationVector",
    value: function setInitializationVector(iv) {
      this._flattened.setInitializationVector(iv);

      return this;
    }
  }, {
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      this._flattened.setProtectedHeader(protectedHeader);

      return this;
    }
  }, {
    key: "setKeyManagementParameters",
    value: function setKeyManagementParameters(parameters) {
      this._flattened.setKeyManagementParameters(parameters);

      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, options) {
        var jwe;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._flattened.encrypt(key, options);

              case 2:
                jwe = _context.sent;
                return _context.abrupt("return", [jwe.protected, jwe.encrypted_key, jwe.iv, jwe.ciphertext, jwe.tag].join('.'));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encrypt(_x, _x2) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }]);

  return CompactEncrypt;
}();